class OpeningHoursPricesHelper {
  constructor() {}

  setup() {
    // Fix remove id text node in include:file
    document.querySelectorAll(".opening-hours-include .vrtx-shared-text-description").forEach(elm => {
      const childNodes = elm.parentElement.childNodes;
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].nodeType == 3) {
          const text = childNodes[i].wholeText.trim();
          if(text != "") {
            childNodes[i].remove();
          }
        }
      }
    });
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = url;
    });
  }

  getFellesteksterAndMomentLib(cb) {
    this.loadScript("/vrtx/dist/resources/js/moment.min.js").then(() => {
      moment.updateLocale("en", { week: {
        dow: 1, // First day of week is Monday
        doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
      }});
      this.getFellestekster(cb);
    });
  }

  getFellestekster(cb) {
    const query = "uri = /vrtx/fellestekst/visit/*";;
    const fields = "*";
    const sort = "publish-date desc";

    this.getPropertySearchResults(query, fields, sort).then((response) => {
      return response.json(); // getting json from response is also a Promise
    }).then((json) => {
      if(json.results && json.results.length > 0) {
        cb(json);
      } else {
        console.error("opening-hours-prices-helper.js: No /vrtx/fellestekst/visit/* found");
      }
    });
  }

  async getPropertySearchResults(query, fields, sort, cb) {
    const queryUrl = "/vrtx/__vrtx/app-services/property-query" +
      "?q=" + encodeURIComponent(query) +
      "&fields=" + encodeURIComponent(fields) +
      "&sort=" + encodeURIComponent(sort) +
      "&format=json-compact" + 
      "&_=" + (+new Date()); // equivalent of jquery cache=false

    return await fetch(queryUrl, {
      headers: {
        "Accept": "application/json;charset=utf-8"
      }
    });
  }

  prepareBoxes(boxes) {
    boxes.forEach(elm => {
      if(elm.classList.contains("vrtx-frontpage-box")) {
        const boxContent = elm.querySelector(".vrtx-box-content");
        if(!boxContent) {
          const boxReadMore = elm.querySelector(".vrtx-more");
          const boxContentHtmlWrapper = `<div class="vrtx-box-content"></div>`;
          if(boxReadMore) {
            boxReadMore.insertAdjacentHTML("beforebegin", boxContentHtmlWrapper);
          } else {
            elm.insertAdjacentHTML("beforeend", boxContentHtmlWrapper);
          }
        }
      }

      // Remove IKKE SLETT box title (is there to prevent webeditor to delete them)
      const frontpageBox = elm.closest(".vrtx-frontpage-box"); // including if self is .vrtx-frontpage-box
      if(frontpageBox) {
        const boxTitle = frontpageBox.querySelector(":scope > h2");
        const isNotEdit = !document.querySelector("body.vrtx-mode-edit");
        if(isNotEdit && boxTitle) {
          boxTitle.remove();
        }
      }
    });
  }
}

export default new OpeningHoursPricesHelper;
